<div id="bar-edit{{index}}"></div>